module.exports = __webpack_public_path__ + "img/mazda-Worth.10fa4c74.png";